export const ALLOWEDCASHPRODUCT = "cash";
export const ALLOWEDMONTHLYPRODUCT = "monthly";
